"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllBookingItemAvailabilityExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const ItemAvailability_1 = tslib_1.__importDefault(require("../__models__/ItemAvailability"));
const getAllBookingItemAvailability = toolkitRaw.createAsyncThunk('items/fetch_all_booking_item_availability', async ({ start_at, end_at, bookingInternalId }, { getState, rejectWithValue }) => {
    var _a, _b, _c, _d, _e;
    try {
        const state = getState();
        const items = ((_b = (_a = state === null || state === void 0 ? void 0 : state.items) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.data) || [];
        const id = bookingInternalId || ((_e = (_d = (_c = state === null || state === void 0 ? void 0 : state.bookings) === null || _c === void 0 ? void 0 : _c.booking) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.internal_id) || '';
        const response = await services_1.default.get(`/api/saas/me/bookings/${id}/availability`, {
            params: {
                start_at,
                end_at,
            },
        });
        const itemImplementation = new ItemAvailability_1.default(items);
        itemImplementation.response = response;
        return itemImplementation.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getAllBookingItemAvailabilityExtraReducers = (builder) => {
    builder.addCase(getAllBookingItemAvailability.pending, (state) => {
        state.booking.slices.availability.loading = true;
    });
    builder.addCase(getAllBookingItemAvailability.fulfilled, (state, action) => {
        state.booking.slices.availability.loading = false;
        state.booking.slices.availability.data = action.payload;
    });
    builder.addCase(getAllBookingItemAvailability.rejected, (state) => {
        state.booking.slices.availability.loading = false;
    });
};
exports.getAllBookingItemAvailabilityExtraReducers = getAllBookingItemAvailabilityExtraReducers;
exports.default = getAllBookingItemAvailability;
//# sourceMappingURL=index.js.map